export default __webpack_public_path__ + "static/media/tutorial_preview_search.745f42c3.png";